import { CLEAR_USERS_LIST, FETCH_USERS_LIST} from "../actionTypes";
import { fetchUserData } from "../../../api/userManagement/userViewer";

const request = () => ({ type: FETCH_USERS_LIST.REQUEST });
const failure = (error) => ({ type: FETCH_USERS_LIST.FAILURE, error });
const success = (data,isLoadMore,next,totalItems) => ({ type: FETCH_USERS_LIST.SUCCESS,data,isLoadMore,next,totalItems});
const clearUserList = () => ({ type: CLEAR_USERS_LIST });



export const getUser= (type,custID,searchKey,next,userNames,roles,sort="") => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchUserData(type,custID,searchKey,next,userNames,roles,sort)
      .then((res) => {
        dispatch(success(res?.rights,!!next, res?.next,res?.totalItems));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};

export const resetUserList = () => {
  return (dispatch) => {
    dispatch(clearUserList());
  };
}